import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ControlCameraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"control_camera"}/>
}
